// Modelo de los datos de un channel
export default class Channel {
    constructor (
         public id: string = '',
         public name: string = '',
    ) {

    }
}
